import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import store from '../store';

import Sponsorship from '../components/friends/Sponsorship';

const page = document.getElementById('sponsorship-page');
if (page) {
    const routes = <Route path="/:locale?/sponsorship" element={<Sponsorship />} />;

    createRoot(page).render(
        <Provider store={store}>
            <Router>
                <Routes>{routes}</Routes>
            </Router>
        </Provider>
    );
}
